module.exports = __webpack_public_path__ + "img/trans-fulltime.2d879049.svg";